<!--Navbar Start-->
<nav
  class="navbar navbar-expand-md sticky-top navbar-custom sticky-dark"
  (window:scroll)="windowScroll()"
  id="navbar"
  style="background-color: white"
>
  <div class="container">
    <!-- LOGO -->
    <a
      class="navbar-brand logo d-flex align-items-center"
      [routerLink]="status() ? ['/home'] : ['/']"
      style="cursor: pointer"
    >
      <img
        src="/assets/images/logo-asah-skill.png"
        alt="Asah Skill"
        height="50"
        class="me-2"
      />
    </a>

    <!-- FIXED TOGGLER -->
    <button
      class="btn btn-md btn-outline-primary mr-4 navbar-burger d-md-none"
      type="button"
      aria-expanded="{{ isMenuOpen }}"
      (click)="toggleMenu()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        fill="currentColor"
        viewBox="0 0 16 16"
      >
        <path
          fill-rule="evenodd"
          d="M1.5 3.5A.5.5 0 0 1 2 3h12a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0 4A.5.5 0 0 1 2 7h12a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5zm0 4A.5.5 0 0 1 2 11h12a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5z"
        />
      </svg>
    </button>

    <!-- FIXED COLLAPSE -->
    <div
      class="navbar-collapse collapse"
      [ngClass]="{ show: isMenuOpen }"
      id="navbarCollapse"
    >
      <!-- =====================  GUEST MENU (NOT LOGGED IN) ===================== -->
      @if (!status()) {
        <ul class="navbar-nav mx-auto navbar-center">
          <li
            class="nav-item"
            [ngClass]="{ active1: currentSection === 'landing' }"
            (click)="scrollTo('landing', 5); closeMenu()"
          >
            <a routerLink="/" fragment="landing" class="nav-link">Home</a>
          </li>

          <li
            class="nav-item"
            [ngClass]="{ active: currentSection === 'about' }"
          >
            <a
              routerLink="/"
              fragment="about"
              class="nav-link"
              (click)="scrollTo('about', 5); closeMenu()"
              >About</a
            >
          </li>

          <li
            class="nav-item"
            [ngClass]="{ active: currentSection === 'partner' }"
          >
            <a
              routerLink="/"
              fragment="partner"
              class="nav-link"
              (click)="scrollTo('partner', 5); closeMenu()"
              >Partner</a
            >
          </li>
        </ul>
      }

      <!-- =====================  LOGGED-IN MENU ===================== -->
      @if (status()) {
        <ul class="navbar-nav mx-auto navbar-center"></ul>
      }

      <!-- Guest: Login + Register -->
      @if (!status()) {
        <div class="d-flex gap-2">
          <button
            class="btn btn-outline-primary rounded-1"
            type="button"
            (click)="loginModal(); closeMenu()"
          >
            Login
          </button>
          <button
            class="btn btn-primary rounded-1"
            type="button"
            (click)="registerModal(); closeMenu()"
          >
            Register
          </button>
        </div>
      }

      <!-- Logged in: Avatar Dropdown Menu -->
      @if (status()) {
        <div class="d-flex w-100 justify-content-end align-items-center gap-3">
          <div ngbDropdown class="d-inline-block">
            <button
              type="button"
              class="btn btn-light d-flex align-items-center gap-2 px-3 py-2"
              id="userDropdown"
              ngbDropdownToggle
              style="border: 1px solid #e0e0e0; border-radius: 50px"
            >
              <div
                class="rounded-circle d-flex align-items-center justify-content-center"
                style="width: 32px; height: 32px; border: 2px solid #e0e0e0"
              >
                @if (userDetail()?.profilePictureUrl) {
                  <img
                    [src]="userDetail()?.profilePictureUrl"
                    alt="Avatar"
                    class="rounded-circle"
                    width="28"
                    height="28"
                  />
                } @else {
                  <i class="bi bi-person-fill text-primary fs-6"></i>
                }
              </div>
              <span class="fw-medium text-dark d-none d-md-inline">{{
                userDetail()?.name || "User"
              }}</span>
            </button>
            <div
              ngbDropdownMenu
              aria-labelledby="userDropdown"
              class="dropdown-menu-end shadow-sm"
            >
              <a ngbDropdownItem routerLink="/profile" (click)="closeMenu()">
                <i class="bi bi-person me-2"></i>Profile
              </a>
              <a
                ngbDropdownItem
                routerLink="/payment/history"
                (click)="closeMenu()"
              >
                <i class="bi bi-receipt me-2"></i>Riwayat Pembayaran
              </a>
              <div class="dropdown-divider"></div>
              <a
                ngbDropdownItem
                (click)="logout(); closeMenu()"
                class="text-danger"
                style="cursor: pointer"
              >
                <i class="bi bi-box-arrow-right me-2"></i>Logout
              </a>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</nav>
